import Swal from "sweetalert2";

// Esta variable vive solo dentro de este módulo
let loadingInstance = null;

const loading = {
    startLoading: () => {
        // Guardamos la instancia devuelta por Swal.fire
        loadingInstance = Swal.fire({
            title: "¡Espere, por Favor!",
            html: "Mientras se procesa la información",
            allowOutsideClick: false,
            showConfirmButton: false,
            didOpen: () => {
                Swal.showLoading();
            },
        });
    },
    closeLoading: () => {
        // Swal.close();
        // Si existe una instancia, la cerramos específicamente
        if (loadingInstance) {
            //Swal.close(); // SweetAlert2 cierra el modal activo
            loadingInstance = null; // Limpiamos la referencia
            setTimeout(() => {
            Swal.close();
        }, 300);
        }
    }
};

export default loading;
